export const MAILICON = 'mail';
export const EMAILINPUTTYPE = 'email';
export const EMAILLABEL = $localize`Email ID`;
export const EMAILPLACEHOLDER = $localize`Your email`;
export const TITLE = $localize`Create New Password`;
export const DESC = $localize`Enter the new password for your account.`;
export const BTNSTYLEFILLEDLARGE = 'btn-filled-large';
export const BTNSTYLEFILLEDLARGEDISABLED = 'btn-filled-large-disabled';
export const SUBMITDISABLED = true;
export const OTP_CODE: string = '';
export const BUTTONSUBMIT = $localize`Signup`;
export const BTNMATFLAT = 'mat-flat-button';
export const BACK = $localize`Back`;
